import { SelectListItem } from './select-property';
import * as t from './select-index'

export enum Items {
    Options_DataType,
    Options_Enabled,
    Options_DataBase,
    Options_DataSource,
    Options_FileType,
    Options_TimeFormat
}

export function GetItems(itemName?: Items, InsertFirst: boolean = false, CustomizeItem: SelectListItem = null): SelectListItem[] {
    console.log(`get items  ${itemName} , InsertFirst = ${InsertFirst}`);

    let ddlItems = new Array<SelectListItem>();

    if (typeof (itemName) !== 'undefined') {
        switch (itemName) {
            case Items.Options_DataType:
                ddlItems = t.Options_DataType.slice(0);
                break;
            case Items.Options_Enabled:
                ddlItems = t.Options_Enabled.slice(0);
                break;
            case Items.Options_DataBase:
                ddlItems = t.Options_DataBase.slice(0);
                break;
            case Items.Options_DataSource:
                ddlItems = t.Options_DataSource.slice(0);
                break;
            case Items.Options_FileType:
                ddlItems = t.Options_FileType.slice(0);
                break;
                case Items.Options_TimeFormat:
                ddlItems = t.Options_TimeFormat.slice(0);
                break;
            default:
                ddlItems = [{ text: '', value: '' }];
                break;
        }

        if (InsertFirst) {
            let firstItem: SelectListItem = { value: '', text: 'All the below', index: 0 };
            ddlItems.unshift(firstItem);
        }
        if (CustomizeItem !== null){
            ddlItems.unshift(CustomizeItem);
        }
        return ddlItems;
    }
    else {
        let items = [{ text: 'test0', value: '1' }];
        return items;
    }
}